import { Skeleton, TableCell, TableRow, Box } from "@mui/material";
import React from "react";

function index(props: any) {
  const { actionsCount, rectangularCells, cellWidths } = props;
  return (
    <TableRow>
      {/* Mirrors the loaded row: a plain cell with the avatar and name laid out
          by an inner flex Box. Putting display:flex on the cell itself drops it
          out of the table layout and throws the column widths off. */}
      <TableCell>
        <Box display={"flex"} alignItems={"center"}>
          <Skeleton variant="circular" width={40} height={40} />
          <Skeleton
            variant="rectangular"
            width={100}
            height={25}
            sx={{ marginLeft: "10px" }}
          />
        </Box>
      </TableCell>
      {Array.from({ length: rectangularCells }).map((cell, index) => {
        return (
          <TableCell key={index}>
            <Skeleton
              variant="rectangular"
              width={cellWidths?.[index] ?? 60}
              height={25}
              sx={{ maxWidth: "100%" }}
            />
          </TableCell>
        );
      })}

      <TableCell>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          {Array.from({ length: actionsCount }).map((actionLoader, index) => {
            return (
              <span key={index}>
                <Skeleton width={30} height={40} />
              </span>
            );
          })}
        </Box>
      </TableCell>
    </TableRow>
  );
}

export default index;
